import { render, staticRenderFns } from "./DietCard.vue?vue&type=template&id=79928a51&scoped=true"
import script from "./DietCard.vue?vue&type=script&lang=js"
export * from "./DietCard.vue?vue&type=script&lang=js"
import style0 from "./DietCard.vue?vue&type=style&index=0&id=79928a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79928a51",
  null
  
)

export default component.exports